import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { IPermission, IRole, IRoleCreation, IUser } from '../core/models/auth.models';
import { getRolesForPage } from '../core/helpers/utility';
import { CurrencyPipe } from '@angular/common';
import { tap as rxjsTap } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class AppService {

    private _pageTitleRelay = new BehaviorSubject<string>('');
    private _activePage: BehaviorSubject<string> = new BehaviorSubject<string>('');
    //Store // TODO: we will move these to index db for caching in future
    private _activeUserInfo: BehaviorSubject<IUser> = new BehaviorSubject<IUser>({} as IUser);
    private _activeUserRoles: BehaviorSubject<Array<any>> = new BehaviorSubject(new Array<any>());
    private _allClientsData: BehaviorSubject<any> = new BehaviorSubject({ data: [], totalCount: 0 });
    private _allProspectClientsData: BehaviorSubject<any> = new BehaviorSubject({ data: [], totalCount: 0 });

    private _changeLayout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _allCampaignsData: BehaviorSubject<any> = new BehaviorSubject({ data: [], totalCount: 0 });
    private _allTasks: BehaviorSubject<any> = new BehaviorSubject({ data: [], totalCount: 0 });
    private _forceLoadingTasks: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _allUsers: BehaviorSubject<Array<IUser>> = new BehaviorSubject(new Array<IUser>());
    private _allLeads: BehaviorSubject<any> = new BehaviorSubject({});
    private _allOrders: BehaviorSubject<any> = new BehaviorSubject({});
    private _allShopOrdersFiltered: BehaviorSubject<any> = new BehaviorSubject({ data: [], totalCount: 0 });
    private _allUserSubscriptions: BehaviorSubject<any> = new BehaviorSubject([]);
    private _allUserPaymentmethods: BehaviorSubject<any> = new BehaviorSubject([]);

    //datafeed
    private _roleRestrictions: BehaviorSubject<Array<IRoleCreation>> = new BehaviorSubject(new Array<IRoleCreation>());
    private _allRoles: BehaviorSubject<Array<IRole>> = new BehaviorSubject(new Array<IRole>());
    //Store


    private _activeRoute: BehaviorSubject<any> = new BehaviorSubject('');

    constructor(
        private router: Router,
    ) { }

    getRoleRestrictions$() {
        return this._roleRestrictions;
    }
    setRoleRestrictions$(r: any) {
        this._roleRestrictions.next(r)
    }
    
    getAllRoles$() {
        return this._allRoles;
    }
    setAllRoles$(r: any) {
        this._allRoles.next(r)
    }
    



    getActivePage$() {
        return this._activePage;
    }
    setActivePage$(r: any) {
        this._activePage.next(r)
    }

    getActiveUser$() {
        return this._activeUserInfo;
    }
    setActiveUser$(r: any) {
        this._activeUserInfo.next(r)
    }

    getActiveUserRoles$() {
        return this._activeUserRoles;
    }
    setActiveUserRoles$(r: any) {
        this._activeUserRoles.next(r)
    }

    getUserRolesForPage(pageName: string): IPermission {
        var doWhat: IPermission = {} as IPermission;
        this.getActiveUser$()
            .subscribe(u => {
                var r = getRolesForPage(u.roles, pageName);
                doWhat.isAdmin = r.isAdmin;
                doWhat.canRead = r.canRead || r.isAdmin;
                doWhat.canWrite = r.canWrite || r.isAdmin;
                doWhat.canDelete = r.canDelete || r.isAdmin;
                doWhat.canCreate = r.canCreate || r.isAdmin;
                if (r.options)
                    doWhat.roleOptions = JSON.parse(r.options!);
            });
        return doWhat;
    }


    getActiveRoute$() {
        return this._activeRoute;
    }
    setActiveRoute$(route: any) {
        this._activeRoute.next(route)
    }

    getAllClients$() {
        return this._allClientsData;
    }
    getAllProspectClients$() {
        return this._allProspectClientsData;
    }
    setAllClients$(data: any) {
        this._allClientsData.next(data)
    }
    setAllProspectClients$(data: any) {
        this._allProspectClientsData.next(data)
    }


    
    getAllTasks$() {
        return this._allTasks;
    }
    setAllTasks$(data: any) {
        this._allTasks.next(data)
    }

    getForceLoadingTasks = () => this._forceLoadingTasks;

    setForceLoadingTasks = (force: boolean) => this._forceLoadingTasks.next(force);

    
    changeLayout(value: boolean) {
        this._changeLayout.next(value);
    }

    getChangeLayoutValue() {
        return this._changeLayout;
    }

    getAllCampaigns$() {
        return this._allCampaignsData;
    }
    setAllCampaigns$(data: any) {
        this._allCampaignsData.next(data)
    }

    getPageTitle$() {
        return this._pageTitleRelay;
    }
    setPageTitle$(title: string) {
        this._pageTitleRelay.next(title)
    }



    getAllUsers$() {
        return this._allUsers;
    }
    setAllUsers$(data: any) {
        this._allUsers.next(data)
    }


    clearData() {
        this._pageTitleRelay = new BehaviorSubject<string>('');
        this._activePage = new BehaviorSubject<string>('');
        //Store // TODO: we will move these to index db for caching in future
        this._activeUserInfo = new BehaviorSubject<IUser>({} as IUser);
        this._activeUserRoles = new BehaviorSubject(new Array<any>());
        this._changeLayout = new BehaviorSubject<boolean>(false);
        this._allRoles = new BehaviorSubject(new Array<IRole>());
    }
}


